import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { DataService } from '../services/data.service';
import { DialogService } from 'primeng/dynamicdialog';
import { ErrorModalComponent } from 'src/app/shared/components/modals/error-modal/error-modal.component';
import { SsoService } from '@devinforius/i-sso';

let hasFinish = false;

export const ErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const ssoService = inject(SsoService);
  const toastr = inject(ToastrService);
  const dataService = inject(DataService);
  const dialog = inject(DialogService);

  const requestToForward = req;

  return next(requestToForward).pipe(
    catchError(
      (err) =>
        new Observable<HttpEvent<unknown>>((observer) => {
          if (err instanceof HttpErrorResponse) {
            const errResp = err;

            // 401 – token expiré / invalide
            if (err.status === 401) {
              if (!ssoService.hasValidAccessToken()) {
                dataService.triggerHttpInvalidOrExpiredToken('token_expired');
              }
            }

            if (
              errResp &&
              errResp.status !== 404 &&
              !errResp.url?.includes('/Me/Avatar') &&
              requestToForward.method !== 'GET'
            ) {
              hasFinish = false;

              const instance = err.error ? err.error?.instance : '';
              if (instance && err.status) {
                dataService.setError({
                  route: instance ? instance.replace('/api/v1/', '') : '',
                  status: err?.status,
                  message: err?.error?.message,
                  code: err?.error?.code,
                  method: requestToForward?.method,
                });
              }

              if (hasFinish === false) {
                const link = `Cliquer ici pour plus d'information`;
                toastr.error(link, 'Des erreurs se sont produites').onTap.subscribe(() => {
                  openModal(dialog, dataService);
                });
              }
            }
          }

          observer.error(err);
          observer.complete();
          hasFinish = true;
        })
    )
  );
};

function openModal(dialog: DialogService, dataService: DataService) {
  const ref = dialog.open(ErrorModalComponent, {
    width: '80vw',
    styleClass: 'super-compos-modal-content ',
    showHeader: false,
    closable: false,
    dismissableMask: false,
    baseZIndex: 1000,
  });

  ref.onClose.subscribe(() => {
    dataService.setError([]);
  });
}
